import * as React from 'react';
import { Box,Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectVideosCount } from "features/videos/videosSlice";
import FigureBox from "../../shared/FigureBox";

const ShowStats = (props) => {

    const allVideosCount = useSelector(selectVideosCount);

    return(
        <>
        <Box sx={{ width: '100%',mt: 3 }}>
            <Grid
                container
                spacing={1}
            >
                <Grid
                    item
                    xs={6}
                    sm={4}
                    md={2}
                >
                    <FigureBox 
                        label="Total Videos"
                        figure={allVideosCount}
                        avatarColor="green"
                        />
                </Grid>
               
            </Grid>
        </Box>
        
        </>
    )

}

export default ShowStats;